module.exports = __webpack_public_path__ + "static/media/vuse-logo.62920748.svg";